import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import React from 'react'

interface CancelInvoiceDialogProps {
    onConfirm: () => void
}

const CancelInvoiceDialog: React.FC<CancelInvoiceDialogProps> = ({ onConfirm }: CancelInvoiceDialogProps) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)

    return (
        <div>
            <Button onClick={() => setIsDialogOpen(true)} variant='outlined' color='error'>
                Smazat
            </Button>
            <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                <DialogTitle>Chcete smazat fakturu?</DialogTitle>

                <DialogActions>
                    <Button onClick={() => setIsDialogOpen(false)} variant='outlined'>
                        Zrušit
                    </Button>
                    <Button onClick={onConfirm} autoFocus variant='contained' color='error'>
                        Smazat
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default CancelInvoiceDialog
